import styled from 'styled-components';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLabelBlock = styled.span.withConfig({
  displayName: "field-labelcomponent__StyledLabelBlock",
  componentId: "sc-ve8kol-0"
})(["display:inline-flex;flex-direction:column;align-items:flex-start;gap:6px;max-width:100%;"]);
var StyledLabelRow = styled.span.withConfig({
  displayName: "field-labelcomponent__StyledLabelRow",
  componentId: "sc-ve8kol-1"
})(["display:inline-flex;align-items:center;gap:4px;"]);
var StyledRequiredMark = styled.span.withConfig({
  displayName: "field-labelcomponent__StyledRequiredMark",
  componentId: "sc-ve8kol-2"
})(["color:", ";"], styleVariables.colors.red4);
var StyledSectionHeader = styled.div.withConfig({
  displayName: "field-labelcomponent__StyledSectionHeader",
  componentId: "sc-ve8kol-3"
})(["margin-bottom:14px;"]);
var StyledSectionTitle = styled.div.withConfig({
  displayName: "field-labelcomponent__StyledSectionTitle",
  componentId: "sc-ve8kol-4"
})(["font-size:14px;font-weight:600;color:#1f2937;margin-bottom:6px;"]);
var StyledSectionDescription = styled.div.withConfig({
  displayName: "field-labelcomponent__StyledSectionDescription",
  componentId: "sc-ve8kol-5"
})(["font-size:12px;line-height:1.5;color:", ";font-weight:400;"], styleVariables.colors.gray10);
var StyledFieldHint = styled.span.withConfig({
  displayName: "field-labelcomponent__StyledFieldHint",
  componentId: "sc-ve8kol-6"
})(["font-size:12px;line-height:1.5;color:", ";font-weight:400;"], styleVariables.colors.gray10);

/** Form label with optional required mark and always-visible explanation. */
export var FieldLabel = function FieldLabel(_ref) {
  var label = _ref.label,
      hint = _ref.hint,
      required = _ref.required;
  return /*#__PURE__*/_jsxs(StyledLabelBlock, {
    children: [/*#__PURE__*/_jsxs(StyledLabelRow, {
      children: [/*#__PURE__*/_jsx("span", {
        children: label
      }), required ? /*#__PURE__*/_jsx(StyledRequiredMark, {
        children: "*"
      }) : null]
    }), hint ? /*#__PURE__*/_jsx(StyledFieldHint, {
      children: hint
    }) : null]
  });
};
export var SectionHeader = function SectionHeader(_ref2) {
  var title = _ref2.title,
      description = _ref2.description;
  return /*#__PURE__*/_jsxs(StyledSectionHeader, {
    children: [/*#__PURE__*/_jsx(StyledSectionTitle, {
      children: title
    }), description ? /*#__PURE__*/_jsx(StyledSectionDescription, {
      children: description
    }) : null]
  });
};